import { fork, put, call, takeLatest, select, all } from 'redux-saga/effects';
import app from '../../app';
import {
  loadNoticeListCompletion,
  loadPopupWindowCompletion,
  loadPayNoticeCompletion,
} from '../../actions';

function* watchLoadNoticeList() {
  yield takeLatest('LOAD_NOTICE_LIST', function*({ client, from }) {
    const own = yield select(state => state.own.own);

    if (!own) {
      yield put(loadNoticeListCompletion(new Error('还没有登录')));
      return;
    }

    // const { didLoadAt } = yield select(state => state.notice.notice);
    // if (new Date().getTime() - didLoadAt < 3 * 60 * 1000) {
    //   yield put(loadNoticeListCompletion(new Error('请求太频繁')));
    //   return;
    // }

    const options = {
      url: '/api/getConfig',
      data: {
        viewFrom: from || '',
      }
    };
    const result = yield call(app.httpFetch, options);

    const popupObj = result.data?.listData.find(item => item.type === 'popup');

    const payNoticeList = popupObj && popupObj.listData
      .filter(item => item.type === 0);

    yield put(
      loadNoticeListCompletion(
        result.error,
        (result.data && result.data.listData) || [],
        new Date().getTime()
      )
    );
    if (popupObj) {
      yield put(loadPopupWindowCompletion(popupObj, client))
    }
    if (payNoticeList && payNoticeList.length) {
      yield put(loadPayNoticeCompletion(payNoticeList, client));
    }
  });
}

export default function* noticeSaga() {
  yield all([fork(watchLoadNoticeList)]);
}
